/* import __COLOCATED_TEMPLATE__ from './prism-question-accordion.hbs'; */
import { not } from '@ember/object/computed';
import Component from '@ember/component';

/**
 * This component provides an expandable question block which toggles
 * to display/hide an answer.
 *
 * It is designed to be used in a series on a larger page.
 *
 * Example component usage:
 *
 * ```hbs
 * {{#prism-question-accordion
 *   question="How should I use this FAQ question?"
 *   questionId=1
 *   iconClass="partner-icon-color"
 *   titleClass="prism-question-accordion_title--partner"}}
 *   Create a bunch of these in a row!
 * {{/prism-question-accordion}}
 * ```
 * or
 *
 * ```hbs
 * {{prism-question-accordion
 *    question="What is the difference between these two questions?"
 *    questionId=2
 *    answer="This one is not used as a block component."}}
 * ```
 *
 * @class PrismQuestionAccordion
 */
export default Component.extend({
  tagName: '',
  init(...args) {
    this._super(...args);
    this.set('isExpanded', !this.get('question'));
  },
  /**
   * Text for the question. **Required**.
   *
   * @argument question
   * @type {String}
   */
  question: null,
  /**
   * Numerical ID of the question.
   *
   * @argument questionId
   * @type {Number}
   */
  questionId: null,
  /**
   * Text for the question answer.
   *
   * If this is not provided the component should be used in block form with the
   * answer in the block.
   *
   * @argument answer
   * @type {String}
   */
  answer: null,
  /**
   * CSS class containing `fill` color for the togle icon to override the
   * default color `$color-blue-200`.
   *
   * @argument iconClass
   * @type {[type]}
   */
  iconClass: '',
  /**
   * CSS class that will allow for additional styling, this allows for the
   * question to be themed.
   *
   * @argument titleClass
   * @type {String}
   */
  titleClass: '',
  /**
   * Action called when the accordion has been expanded.
   *
   * @argument didExpand
   * @type {Action}
   */
  didExpand() {},
  isExpanded: false,
  isCollapsed: not('isExpanded'),
  toggleAccordion() {
    if (this.toggleProperty('isExpanded')) {
      this.didExpand();
    }
  }
});